import { useQuery } from 'react-query';
import { getQueryKeys } from './queryKeys';
import { getFlatsGridTemplates } from '../requests/flatsGridByFile';

export const useFlatsGridTemplatesQuery = (options) =>
  useQuery(getQueryKeys.flatsGridTemplates(), () => getFlatsGridTemplates(), {
    staleTime: Infinity,
    ...options,
  });
